


import{useState,useEffect, useCallback} from 'react'
import Button from "@/components/ui/Button"

import { useShow } from "@/contexts/ShowContext"
import { FiSave, FiPlus, FiTrash } from "react-icons/fi"
import { Textarea } from '@/components/ui/shadcn/textarea'
import { LuLoaderCircle } from 'react-icons/lu'
import { LuCheck } from 'react-icons/lu'
import { Input } from '@/components/ui/shadcn/input'
import { Switch } from '@/components/ui/shadcn/switch'
import { useModal } from '@/contexts/ModalContext'
import ConfirmModal from '@/components/modals/ConfirmModal'

export default function ShowInstructionsPage() {
    const {show, saveShow} = useShow()
    const [saving, setSaving] = useState(false)
    const [selectedInstruction, setSelectedInstruction] = useState(show.instructions?.length > 0 ? 0 : null)
    const [instructions, setInstructions] = useState(show.instructions || [])
    const [saveTimeout, setSaveTimeout] = useState(null)
    const [allowSave, setAllowSave] = useState(false)
    const [segments, setSegments] = useState(show.segments || [])
    const [selectedSegment, setSelectedSegment] = useState(segments.length > 0 ? 0 : null)

    const [selection, setSelection] = useState(null)
    
    const {openModal} = useModal()
    
    const debouncedSave = () =>{
        if(saveTimeout) clearTimeout(saveTimeout)
        setSaveTimeout(setTimeout(handleSave, 2000))
    }

    const handleSave = async () => {
        try{
            setSaving(true)
            await saveShow({instructions, segments})
        } catch (error) {
            console.error(error)
        } finally {
            setSaving(false)
        }
    }

    const handleInstructionAdd = () => {
        setInstructions([...instructions, {name: 'New Topic', instruction: '', _id: crypto.randomUUID()}])
        setAllowSave(true)
    }

    const handleSegmentAdd = () => {
        setSegments([...segments, {name: 'New Segment', instruction: '', _id: crypto.randomUUID()}])
        setAllowSave(true)
    }

    const handleChange = (prop) => {
        setSelection({...selection, ...prop})
        if(instructions.find(instruction => instruction._id === selection?._id)){
            setInstructions(instructions.map((instruction) => instruction._id === selection?._id ? {...instruction, ...prop} : instruction))
            setAllowSave(true)
        }else if(segments.find(segment => segment._id === selection?._id)){
            setSegments(segments.map((segment) => segment._id === selection?._id ? {...segment, ...prop} : segment))
            setAllowSave(true)
        }
    }

    const handleDelete = async() => {
        const confirm = await openModal(<ConfirmModal title='Delete' message='Are you sure you want to delete this topic?' />)
        if(!confirm) return

        setInstructions(instructions.filter(instruction => instruction._id !== selection?._id))
        setSegments(segments.filter(segment => segment._id !== selection?._id))
        setAllowSave(true)
        setSelection(null)
    }

    useEffect(() => {
        if(allowSave){
            debouncedSave()
        }
    }, [instructions, segments])

    return (
        <div className="flex flex-1 flex-col overflow-hidden">
            <div className='flex justify-between items-center px-10 h-20 '>
                <div className='flex gap-2'>
                    <h1 className='text-2xl font-bold border-l-4 border-primary pl-4'>Instructions</h1>
                </div>
                <div className='flex gap-2'>
                    {/* <Button type='secondary' icon={<FiSave className="w-4 h-4" />} onClick={handleSave}>Save</Button> */}
                    <div className='flex items-center gap-2 w-20'>
                        {saving ? <LuLoaderCircle className='w-4 h-4 animate-spin text-secondary-foreground' /> : <LuCheck className='w-4 h-4 text-secondary-foreground' />}
                        <span className='text-xs text-secondary-foreground'>{saving ? 'Saving...' : 'Saved'}</span>    
                    </div>
                </div>
            </div>

            <div className='flex flex-1 py-4 px-10 gap-6 overflow-hidden'>
                <div className='flex flex-col min-w-80 gap-4'>
                    <div className='flex flex-col gap-2 flex-1 border rounded-md overflow-hidden'>
                        <div className='flex items-center justify-between p-2 '>
                            <div className='text-lg text-secondary-foreground font-bold'>General</div>
                            <Button type='secondary' size='sm' icon={<FiPlus className='w-3 h-3' />} onClick={handleInstructionAdd}>New Topic</Button>
                        </div>
                        
                        <div className='flex flex-col flex-1 overflow-y-auto px-2'>
                            {instructions?.map((instruction) => (
                                <div key={instruction._id} className={`flex flex-none items-center gap-2 p-2 rounded-md overflow-hidden hover:bg-secondary cursor-pointer ${selection?._id === instruction._id ? 'text-primary' : ''}`} onClick={() => setSelection(instruction)}>
                                    <span className='text-sm text-secondary-foreground'>{instruction.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className='flex flex-col gap-2 flex-1 border rounded-md overflow-hidden'>
                        <div className='flex items-center justify-between p-2 '>
                            <div className='text-lg text-secondary-foreground font-bold'>Segments</div>
                            <Button type='secondary' size='sm' icon={<FiPlus className='w-3 h-3' />} onClick={handleSegmentAdd}>New Topic</Button>
                        </div>
                        
                        <div className='flex flex-col flex-1 overflow-y-auto'>
                            {segments?.map((segment, index) => (
                                <div key={index} className={`flex flex-none items-center gap-2 p-2 rounded-md overflow-hidden hover:bg-secondary cursor-pointer ${selection?._id === segment._id ? 'text-primary' : ''}`} onClick={() => setSelection(segment)}>
                                    <span className='text-sm text-secondary-foreground'>{segment.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                {selection !== null && <div className='flex flex-1 flex-col gap-2 max-w-3xl'>
                    <div className='flex items-center gap-2'>
                        <Input type='text' className='text-lg flex-1' value={selection?.name || ''} onChange={(e) => handleChange({name: e.target.value})} />
                        <div className='flex items-center gap-2'>
                            <Button type='danger' icon={<FiTrash className='w-4 h-4' />} onClick={handleDelete} />
                        </div>
                    </div>
                    <Textarea className='w-full h-full resize-none text-[12px] text-secondary-foreground' value={selection?.instruction || ''} onChange={(e) => handleChange({instruction: e.target.value})} />
                </div>}
            </div>
        </div>
    )
}
